<template>
  <Bar ref="chartRef" :data="chartData" :options="normalizedOptions" />
</template>

<script setup>
import { computed, ref } from 'vue'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { normalizeChartOptions } from './chartOptions'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const props = defineProps({
  chartData: { type: Object, required: true },
  options:   { type: Object, default: () => ({}) },
})

const chartRef = ref(null)
const normalizedOptions = computed(() => normalizeChartOptions(props.options))
defineExpose({ get chart() { return chartRef.value?.chart } })
</script>
